var metric, imperial;

metric = {
  Nm: {
    name: {
      singular: "Newton-meter",
      plural: "Newton-meters",
    },
    to_anchor: 1,
  },
  mNm: {
    name: {
      singular: "Milli Newton-meter",
      plural: "Milli Newton-meters",
    },
    to_anchor: 0.001,
  },
  dNm: {
    name: {
      singular: "Deci Newton-meter",
      plural: "Deci Newton-meters",
    },
    to_anchor: 0.1,
  },
  cNm: {
    name: {
      singular: "Centi Newton-meter",
      plural: "Centi Newton-meters",
    },
    to_anchor: 0.01,
  },
  "kgf.m": {
    name: {
      singular: "Kilogram-force Meter",
      plural: "Kilogram-force Meters",
    },
    to_anchor: 9.80665,
  },
  "kgf.cm": {
    name: {
      singular: "Kilogram-force Centimeter",
      plural: "Kilogram-force Centimeters",
    },
    to_anchor: 0.0980665,
  },
  "kgf.mm": {
    name: {
      singular: "Kilogram-force Millimeter",
      plural: "Kilogram-force Millimeters",
    },
    to_anchor: 0.00980665,
  },
  "ozf.in": {
    name: {
      singular: "Ounce-force Inch",
      plural: "Ounce-force Inches",
    },
    to_anchor: 0.00706155183333,
  },
  "ozf.ft": {
    name: {
      singular: "Ounce-force Foot",
      plural: "Ounce-force Feet",
    },
    to_anchor: 0.08473862199996,
  },
};

imperial = {
  "Lbf.in": {
    name: {
      singular: "Pound Force-Inch",
      plural: "Pound Force-Inches",
    },
    to_anchor: 1 / 12,
  },
  "Lbf.ft": {
    name: {
      singular: "Pound Force-Foot",
      plural: "Pound Force-Feet",
    },
    to_anchor: 1,
  },
};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: "Nm",
      ratio: 1 / 1.35582,   // metric → imperial: 1 Nm = 0.737562 Lbf.ft
    },
    imperial: {
      unit: "Lbf.ft",
      ratio: 1.35582,        // imperial → metric: 1 Lbf.ft = 1.35582 Nm
    },
  },
};
